import React, { useEffect, useState } from 'react'
import { Modal } from "react-bootstrap";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { getUserListApi } from '../../services/User';




function UserDataModel({ userModel, setUserCloseModel, getUserData }) {

  const [getData, setData] = useState()
  const [rows, setRows] = useState([]);

  async function getUserList() {
    try {
      const response = await getUserListApi(getUserData)
      const { data } = await response
      setRows(data?.questions)
      setData(data)
    } catch (error) {
      console.error("Error fetching product data:", error);
    }
  }

  useEffect(() => {
    getUserData?.id && getUserList()
  }, [getUserData]);


  const getInvestmentRecommendation = () => {
    return Object.entries(getData?.investmentRecommendation).map(([key, value]) => <h6>{key}: {value}</h6>)
  }

  return (
    <>
      <Modal
        show={userModel}
        centered
        onHide={() => {
          setUserCloseModel();
        }}
        style={{ display: "block" }}
        size="xl"
      >
        <Modal.Header className="modal-header" closeButton>
        </Modal.Header>
        <Modal.Body className="modal-body">
          <div className="deadline-form">

            <h5>Name: {getData?.name}</h5>
            <h5>Email: {getData?.email}</h5>
            <h5>Risk Profile: {getData?.riskCategory}</h5>
            <div className='d-flex align-items-center gap-2'>
              {getData?.investmentRecommendation ? getInvestmentRecommendation() : ""}
            </div>

            <div>
              <TableContainer component={Paper}>
                <Table aria-label="spanning table">
                  <TableHead>
                    <TableRow>
                      <TableCell>question</TableCell>
                      <TableCell>selectedOption</TableCell>
                      <TableCell>score</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows?.map((row) => (
                      <TableRow key={row?.id}>
                        <TableCell>{row?.questionText}</TableCell>
                        <TableCell>{row?.answer?.label ? row?.answer?.label : row?.answer}</TableCell>
                        <TableCell >{row?.score}</TableCell>
                      </TableRow>
                    ))}
                    <TableRow>
                      <TableCell rowSpan={3} />
                      <TableCell />
                      <TableCell >Total : {getData?.totalScore}</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>

            </div>
            <div className='d-flex justify-content-end mt-2'>
              <button
                onClick={() => {
                  setUserCloseModel();
                }}
                type="button"
                className="btn btn-secondary"
              >
                Cancel
              </button>
            </div>

          </div>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default UserDataModel